import {
  Button,
  Grid,
  OutlinedInput,
  Paper,
  Typography,
  Table,
  TableContainer,
  TableHead,
} from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import { Fragment, useEffect, useState } from "react";
import Storing from "./Storing";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { CompanyTitledPage } from "../TitledPage";
import SearchForm from "./SearchForm";
import { CompanyPartHeader } from "../../components/PartHeader";
import { getContainerShippingSummary } from "../../http/api/ContainerAPI";
import { getBuyer } from "../../http/api/BuyerAPI";

const infoTableCellSx = {
  fontSize: 17,
};

const Container = () => {
  const columns = ["No", "買人", "先月残", "返却", "貸出", "当月残"];
  const [openStoring, setOpenStoring] = useState(true);
  const [listSummary, setListSummary] = useState([]);
  const [buyers, setBuyers] = useState([]);

  useEffect(() => {
    GetBuyers();
  }, []);

  async function handleSearch(searchData) {
    console.log(searchData);
    const response = await getContainerShippingSummary(searchData);
    console.log(response.listSummaryContainerShippingInfo);
    setListSummary(response.listSummaryContainerShippingInfo);
  }
  async function GetBuyers() {
    try {
      let response = await getBuyer({});
      let listInfo = response.listBuyerInfo;
      listInfo = listInfo
        .map((o) => ({
          buyerNo: o.buyerNo,
          buyerName: o.buyerName,
        }))
        .sort((a, b) => a.buyerNo - b.buyerNo);
      setBuyers(listInfo);
      console.log("買人リスト取得");
    } catch (e) {
      console.log("買人リストを取得する際にエラー発生した：", e);
    }
  }

  return (
    <Fragment>
      <CompanyTitledPage title="コンテナ入出管理">
        <SearchForm search={handleSearch} buyers={buyers} />

        <CompanyPartHeader>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            my={1}
          >
            <Grid item xs="auto">
              <Typography fontWeight="bold" fontSize={20}>
                検索結果
                {listSummary.length > 0
                  ? `（件数：${listSummary.length}）`
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs="auto">
              <OutlinedInput
                type="date"
                inputProps={{
                  min: "1000-01-01",
                  max: "9999-12-31",
                }}
                sx={{ width: 200 }}
                // onChange={(e) =>
                //   searchForm.update("containerShippedAtFrom", e.target.value)
                // }
                // value={searchForm.Value.containerShippedAtFrom}
              />
              &nbsp;の時点&nbsp;
              <Button variant="outlined" onClick={() => setOpenStoring(true)}>
                コンテナを返却
              </Button>
            </Grid>
          </Grid>
        </CompanyPartHeader>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 900 }}>
            <TableHead>
              <TableRow>
                {columns.map((columnName, i) => {
                  return (
                    <TableCell
                      key={`${columnName}_${i}`}
                      sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                    >
                      {columnName}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {listSummary.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: blueGrey[50],
                    },
                  }}
                >
                  {/* No */}
                  <TableCell sx={{ ...infoTableCellSx, width: 50 }}>
                    {index + 1}
                  </TableCell>
                  {/* 買人 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 500 }}>
                    {data.buyerNo + " - " + data.buyerName}
                  </TableCell>
                  {/* 先月残 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                    {data.lastMonthRemain}
                  </TableCell>
                  {/* 出荷 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                    {data.shippingQuantity}
                  </TableCell>
                  {/* 入荷 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                    {data.arrivalQuantity}
                  </TableCell>
                  {/* 当月残 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                    {data.currentRemain}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CompanyTitledPage>

      <Storing open={openStoring} setOpen={setOpenStoring} buyers={buyers} />
    </Fragment>
  );
};
export default Container;
